import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "@chakra-ui/react";
import { routes } from "~/constants";
import { trackFooter as track, TrackUIEvent } from "~/events";
import { FooterLink } from "./FooterLink";

const { VITE_TYPEFORM_COACH_LINK, VITE_TYPEFORM_PROVIDER_LINK } = import.meta
  .env;

const handleLinkClick = (trackEvent: TrackUIEvent) => () => {
  trackEvent();
};

// TODO: After updating this with reskinning stuff, review app/frontend/locales/en/navigation.ts for dead code
export const UnrequiredLinks: FC = () => {
  const { t } = useTranslation();

  return (
    <Flex wrap="wrap" align="center" mb={4} justify="center">
      <FooterLink
        onClick={handleLinkClick(track.howItWorksLink)}
        to={routes.howItWorks}
      >
        {t("navigation.howItWorks")}
      </FooterLink>
      <FooterLink
        onClick={handleLinkClick(track.clinicsLink)}
        to={routes.clinics}
      >
        {t("navigation.clinics")}
      </FooterLink>
      <FooterLink onClick={handleLinkClick(track.aboutLink)} to={routes.about}>
        {t("navigation.about")}
      </FooterLink>
      <FooterLink
        onClick={handleLinkClick(track.careersLink)}
        to={routes.careers}
      >
        {t("navigation.careers")}
      </FooterLink>
      <FooterLink
        onClick={handleLinkClick(track.becomeCoachLink)}
        to={VITE_TYPEFORM_COACH_LINK}
        isExternalLink
      >
        {t("navigation.coach")}
      </FooterLink>
      <FooterLink
        onClick={handleLinkClick(track.becomeProviderLink)}
        to={VITE_TYPEFORM_PROVIDER_LINK}
        isExternalLink
        isLast
      >
        {t("navigation.provider")}
      </FooterLink>
    </Flex>
  );
};
